import { Injectable } from '@angular/core';

import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UrlService {
  static get host(): string {
    return environment.api;
  }

  protected get signUpURL(): string {
    return UrlService.host + 'accounts';
  }

  protected get accountsCheckURL(): string {
    return UrlService.host + 'accounts/check/action';
  }

  protected get loginURL(): string {
    return UrlService.host + 'accounts/login';
  }

  protected get verifyOtpURL(): string {
    return UrlService.host + 'accounts/verify';
  }

  protected get verifyUpdateMobileOtpURL(): string {
    return UrlService.host + 'accounts/update-mobile';
  }
  protected get resendOtpURL(): string {
    return UrlService.host + 'accounts/resend-otp';
  }

  protected get categoriesURL(): string {
    return UrlService.host + 'categories?limit=5&page=0';
  }

  protected get categoriesMainURL(): string {
    return UrlService.host + 'main/categories';
  }

  protected get categoriesSetURL(): string {
    return UrlService.host + 'accounts/category/subcategory/details';
  }

  protected get categoriesDetailsURL(): string {
    return UrlService.host + 'accounts/details';
  }

  protected get whoAmiURL(): string {
    return (
      UrlService.host +
      'accounts?populates=accountsCategories.mainCategory.category.subCategory.accountCategorySubcategories'
    );
  }

  protected get forgotURL(): string {
    return UrlService.host + 'accounts/forgot-password';
  }

  protected get resetURL(): string {
    return UrlService.host + 'accounts/reset-password';
  }

  protected get subcategoriesURL(): string {
    return UrlService.host + 'form/categories/subcategories';
  }

  protected get criticalElementsURL(): string {
    return UrlService.host + 'critical-elements?limit=0&page=0';
  }

  protected get recyclerCriticalFormURL(): string {
    return UrlService.host + 'form/critical-recycler';
  }

  protected get recyclerCriticalOthersFormURL(): string {
    return UrlService.host + 'form/critical-recycler/others';
  }

  protected get details(): string {
    return UrlService.host + 'dashboard/category/details';
  }

  protected get recyclerFormURL(): string {
    return UrlService.host + 'form/nonferrous';
  }

  protected get tradersFormURL(): string {
    return UrlService.host + 'form/nonferrous';
  }

  protected get dismentelerFormURL(): string {
    return UrlService.host + 'form/nonferrous';
  }

  protected get agregatorFormURL(): string {
    return UrlService.host + 'form/nonferrous';
  }

  protected get collectiveCenterFormURL(): string {
    return UrlService.host + 'form/nonferrous';
  }

  protected get subCategoriesAssociateURL(): string {
    return UrlService.host + 'sub-categories?filters[isAssociate]=1';
  }

  protected get formAssociateURL(): string {
    return UrlService.host + 'form/associate';
  }

  protected get isriURL(): string {
    return UrlService.host + 'isri-values?limit=0';
  }

  protected get hsValuesURL(): string {
    return UrlService.host + 'hs-values?limit=0';
  }

  protected get preprocessValuesURL(): string {
    return UrlService.host + 'preprocess-values?limit=0';
  }

  protected get monitoringValuesURL(): string {
    return UrlService.host + 'monitoring/values?limit=0';
  }
  protected get pollutionValuesURL(): string {
    return UrlService.host + 'pollution/equipment?limit=0';
  }
  protected get gstURL(): string {
    return UrlService.host + 'gst/';
  }
  protected get panURL(): string {
    return UrlService.host + 'panverify/';
  }
}
